import React from "react";
import moment from "moment";
import $ from "jquery";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import "./EstiloDetalle.css";
export default class ResultadoConsultaEliminadas extends React.Component {
  async componentDidMount() {
    this.CargarDatatable(this.props.datos);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.datos !== this.props.datos) {
      this.CargarDatatable(this.props.datos);
    }
  }

  redireccionarDetalles = async (data) => {
    await this.props._CargarDetalles(data);
    this.setState({
      verDatatable: this.props.mostrarDatatable,
    });
  };

  CargarDatatable(datos) {
    this.$el = $(this.el);

    $.fn.dataTable.ext.errMode = "throw";
    $.fn.dataTable.moment("DD/MM/YYYY hh:mm A");

    this.$el.DataTable({
      language: LenguageTabla,
      iDisplayLength: 10,
      processing: true,
      destroy: true,
      data: datos,
      columns: [
        {
          class: "dt-control2",
          orderable: false,
          data: null,
          defaultContent: "",
        },
        {
          data: "numeroAutorizacion",
        },
        { data: "tipoAutorizacion.descripcion" },
        { data: "identificacion.tipoPersona.nombre" },
        { data: "identificacion.codigo" },
        { data: "fechaEliminacion" },
        { data: "nombreAutorizado" },
        {
          data: "fechaTramite",
          render: function (data) {
            return moment(data).format("DD/MM/YYYY hh:mm A");
          },
        },

        {
          data: null,
          render: function (data) {
            return data.nombrePersonaTramito ?? data.usuarioTramite;
          },
        },
        {
          data: "fechaEliminacion",
          render: function (data) {
            return moment(data).format("DD/MM/YYYY hh:mm A");
          },
        },
        { data: "nombrePersonaElimino" },
      ],
      order: [5, "desc"],
      columnDefs: [
        {
          targets: [5],
          visible: false,
          orderable: true,
        },
      ],
    });

    var table = $("#tbEliminadas").DataTable();
    $("#tbEliminadas").off("click");

    $("#tbEliminadas").on("click", "tr.odd>td, tr.even>td", function (e) {
      e.preventDefault();
      var tr = $(this).closest("tr");
      var row = table.row(tr);
      if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
        tr.removeClass("shown");
      } else {
        let data = row.data();
        row
          .child(
            `
                <table  cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                <tr>
                <th class="font-weight-bold">Motivo Eliminación </th>
                </tr>
                <tr>
                <td>${data.motivoEliminacion}</td>
                </tr>
                </table>`
          )
          .show();
        tr.addClass("shown");
      }
    });
  }

  render() {
    return (
      <div>
        <div className="card shadow mb-4">
          <div className="card-body">
            <br />
            <table
              ref={(el) => (this.el = el)}
              border="0"
              id="tbEliminadas"
              className="table table-striped display"
            >
              <thead>
                <tr>
                  <th className="details-control sorting_disabled" disabled>
                    Detalle
                  </th>
                  <th>No. Autorización</th>
                  <th>Tipo Autorización</th>
                  <th>Tipo Persona</th>
                  <th>Identificación</th>
                  <th>Fecha</th>
                  <th>Nombre</th>
                  <th>Fecha Trámite</th>
                  <th>Usuario Trámite</th>
                  <th>Fecha Elimina</th>
                  <th>Usuario Eliminó</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
